"use strict";
import React from "react";
import Rectangle from "./rectangle";
import Vector from "immutable-vector2d";
import "../../api/api";
const getFontSize = (props) => props.canvasHeight * 12 / 792;
const TextElement = (props) => {
  const lines = ((props.data || {}).text || "Edit text...").split(/\r?\n/);
  return /* @__PURE__ */ React.createElement("g", { transform: `translate(${props.x},${props.y})` }, /* @__PURE__ */ React.createElement(
    Rectangle,
    {
      width: props.width,
      height: props.height,
      cursor: props.annotating ? "move" : "default",
      stroke: props.selected ? "#aaa" : "#ddd",
      strokeWidth: props.annotating ? 2 : 0,
      fill: "#fff"
    }
  ), /* @__PURE__ */ React.createElement(
    "text",
    {
      transform: `translate(${Math.trunc(props.width) / 100},${Math.trunc(props.height) / 20})`,
      stroke: "#333",
      strokeWidth: 1,
      strokeLinecap: "round",
      fill: "#333",
      style: {
        cursor: props.annotating ? "move" : "default",
        strokeLinejoin: "round",
        fontSize: getFontSize(props),
        whiteSpace: "pre",
        dominantBaseline: "central"
      }
    },
    lines.map((line, i) => /* @__PURE__ */ React.createElement("tspan", { key: i, x: 0, y: `${i * 1.1 + 0.5}em` }, line))
  ));
};
TextElement.calculateDragPoints = function(x, y, width, height) {
  return [
    { x, y },
    { x: x + width, y },
    { x: x + width, y: y + height },
    { x, y: y + height }
  ].map(Vector.fromObject);
};
TextElement.typeID = "TextAnnotation";
TextElement.displayName = "TextAnnotation";
TextElement.getBoundingBox = function(dragPoints) {
  const multipliers = [
    [-1, -1],
    [1, -1],
    [1, 1],
    [-1, 1]
  ];
  return dragPoints.map((point, idx) => {
    return [point.x + multipliers[idx][0], point.y + multipliers[idx][1]];
  });
};
export default TextElement;
